<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path d="m16.49 15 8.2-8.2a1.05 1.05 0 1 0-1.49-1.5L15 13.52l-8.2-8.2A1.05 1.05 0 1 0 5.3 6.8l8.21 8.2-8.2 8.2a1.05 1.05 0 1 0 1.49 1.5l8.2-8.21 8.2 8.2a1.05 1.05 0 0 0 1.5-1.49L16.48 15Z" fill="currentColor" stroke="currentColor" />
  </svg>
</template>
